import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: Variant;
  readonly loading?: boolean;
  readonly children: ReactNode;
}

/**
 * The `danger` variant is reserved for actions that cannot be undone. Irreversible actions must
 * be visually distinct (plan §11) — but they are never distinguished by colour alone, so callers
 * pair it with explicit wording.
 */
export function Button({
  variant = 'secondary',
  loading = false,
  disabled,
  children,
  className,
  ...rest
}: ButtonProps): ReactNode {
  return (
    <button
      type="button"
      {...rest}
      className={['button', `button--${variant}`, className].filter(Boolean).join(' ')}
      disabled={disabled === true || loading}
      aria-busy={loading || undefined}
    >
      {loading ? <span className="button__spinner" aria-hidden="true" /> : null}
      {children}
    </button>
  );
}
